// extracted by mini-css-extract-plugin
export default {"wrapper":"bNebT","full":"oUBfw"};